<template>
	<div style="display: flex; flex-direction: column; flex-grow: 1">
		<v-autocomplete
			label="Headers"
			multiple
			chips
			deletable-chips
			v-model="selectedFields"
			:items="formFields"
			item-text="Label"
			item-value="Id"
		></v-autocomplete>
		<div style="align-self: flex-end">
			<v-btn class="primary" @click="submit()"> Submit </v-btn>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { InventoryFormMobileAppConfigActions } from '../../../../store/actions';
import { InventoryFormMobileAppConfigGetters } from '../../../../store/getters';
export default {
	name: 'MobileAppConfig',
	data() {
		return { selectedFields: [] };
	},
	computed: {
		...mapGetters({
			formFields: [InventoryFormMobileAppConfigGetters.FORM_FIELDS],
		}),
	},
	mounted() {
		this.$store
			.dispatch(
				InventoryFormMobileAppConfigActions.LOAD,
				this.$route.params.id
			)
			.then((resp) => {
				if (resp)
					this.selectedFields = resp.filter(
						(f) => f.MobileHeader == true
					);
			});
	},
	destroyed() {
		this.$store.dispatch(InventoryFormMobileAppConfigActions.CLEAR);
	},
	methods: {
		submit() {
			this.$store.dispatch(
				InventoryFormMobileAppConfigActions.UPDATE_MOBILE_HEADERS,
				{
					inventoryFormId: this.$route.params.id,
					formFields: this.selectedFields,
				}
			);
		},
	},
};
</script>
